export const GREEN_COLOR = "#61bd4f";
export const RED_COLOR = "#eb5a46";
export const YELLOW_COLOR = "#f2d600";
export const BLUE_COLOR = "#3886EE";
